export enum ProductUnitPackagingHandlingPictogramField {
    ProductUnit = 1,
    PackagingHandlingPictogram = 2
}

(ProductUnitPackagingHandlingPictogramField as any).__typeName = 'ProductUnitPackagingHandlingPictogramField';